var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.items.length === 1)?[_vm._v(" "+_vm._s(_vm.items[0])+" ")]:[_c('ul',_vm._l((_vm.items),function(text){return _c('li',[_vm._v(_vm._s(text))])}),0)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }